// extracted by mini-css-extract-plugin
export var active = "FooterMenu-module--active--21e93";
export var column = "FooterMenu-module--column--ffbde";
export var expand = "FooterMenu-module--expand--31302";
export var headerInsert = "FooterMenu-module--headerInsert--ac39c";
export var mobMenuBody = "FooterMenu-module--mobMenuBody--9825d";
export var mobMenuHead = "FooterMenu-module--mobMenuHead--3d38e";
export var root = "FooterMenu-module--root--15e5a";